import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import img$1 from '../../../../assets/images/icon-menu.svg.js';
import img from '../../../../assets/images/icon-close.svg.js';
import css_248z from './pcm-navigation.scss.js';

class PcmNavigation extends s {
    constructor() {
        super(...arguments);
        this.menus = [];
        this.headerlinksdata = [];
        this.phoneNumber = '888-726-5066';
        this.phoneNumberLabel = 'Call for Express Service';
        this.mobileMenuIsOpen = false;
        this.openSubmenusIndex = [];
    }
    toggleMobileMenu() {
        this.mobileMenuIsOpen = !this.mobileMenuIsOpen;
        this.updateMenuVisibility();
        if (!this.mobileMenuIsOpen) {
            this.openSubmenusIndex = [];
        }
    }
    updateMenuVisibility() {
        var _a;
        const mainMenu = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('mainmenu');
        mainMenu === null || mainMenu === void 0 ? void 0 : mainMenu.classList.toggle('menu-open', this.mobileMenuIsOpen);
    }
    toggleSubmenu(index) {
        const currentIndex = this.openSubmenusIndex.indexOf(index);
        if (currentIndex > -1) {
            this.openSubmenusIndex = this.openSubmenusIndex.filter(i => i !== index);
        }
        else {
            this.openSubmenusIndex = [...this.openSubmenusIndex, index];
        }
    }
    renderTopBar() {
        var _a;
        if (!this.phoneNumber && !this.phoneNumberLabel)
            return null;
        return x `<div class="top-bar"><a href="${`tel:${(_a = this.phoneNumber) === null || _a === void 0 ? void 0 : _a.replace(/\D/g, '')}`}">${this.phoneNumberLabel} ${this.phoneNumber}</a></div>`;
    }
    renderStaticLinks() {
        return x `<ul class="main-nav__anchors">${this.headerlinksdata.map(link => this.renderHeaderMenuItem(link))}</ul>`;
    }
    renderNavItem(item) {
        return x `<li><a href="${item.link}" class="nav-links" target="${item.target || ''}">${item.title}</a></li>`;
    }
    renderHeaderMenuItem(item) {
        return x `<li><a href="${item.url}" class="nav-links">${item.text}</a></li>`;
    }
    renderLogo() {
        return x `<div class="main-nav__logo"><a href="/" aria-label="Patient Care Medical"><slot name="logo"></slot></a></div>`;
    }
    renderMobileMenuToggle() {
        return x `<button class="mobile-menu-trigger" @click="${this.toggleMobileMenu}" aria-expanded="${this.mobileMenuIsOpen}" aria-controls="mainmenu"><img loading="lazy" alt="" aria-hidden="true" src="${this.mobileMenuIsOpen ? img : img$1}"></button>`;
    }
    renderMainLinks() {
        return x `<div class="main-links"><ul class="main-links__menu" id="mainmenu" role="menu"><div class="mobile-only-links">${this.headerlinksdata.map(link => this.renderHeaderMenuItem(link))}</div>${this.menus.map((menu, index) => menu.items.length
            ? this.renderMenuWithItems(menu, index)
            : this.renderNavItem(menu))}</ul></div>`;
    }
    renderMenuWithItems(menu, index) {
        const isSubmenuOpen = this.openSubmenusIndex.includes(index);
        return x `<li><div class="nav-links with-submenu" @click="${() => this.toggleSubmenu(index)}" tabindex="0" @keydown="${(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.toggleSubmenu(index);
            }
        }}" role="menuitem" aria-expanded="${isSubmenuOpen}" aria-controls="${`submenu-${index}`}" aria-haspopup="true">${menu.title} <span class="submenu-toggle">${isSubmenuOpen ? '▼' : '►'}</span></div>${this.renderItems(menu.items, isSubmenuOpen, index)}</li>`;
    }
    renderItems(items, isOpen = false, parentIndex) {
        if (!(items === null || items === void 0 ? void 0 : items.length))
            return null;
        return x `<ul class="sublinks ${isOpen ? 'submenu-open' : ''}" id="${`submenu-${parentIndex}`}" role="menu" aria-hidden="${!isOpen}">${items.map(item => this.renderNavItem(item))}</ul>`;
    }
    render() {
        return x `<nav class="nav-container"><slot name="topbar"></slot><div class="main-nav">${this.renderLogo()} ${this.renderStaticLinks()} ${this.renderMobileMenuToggle()}</div>${this.renderMainLinks()}</nav>`;
    }
}
PcmNavigation.styles = css_248z;
__decorate([
    n({ type: Array })
], PcmNavigation.prototype, "menus", void 0);
__decorate([
    n({ type: Array })
], PcmNavigation.prototype, "headerlinksdata", void 0);
__decorate([
    n({ type: String })
], PcmNavigation.prototype, "phoneNumber", void 0);
__decorate([
    n({ type: String })
], PcmNavigation.prototype, "phoneNumberLabel", void 0);
__decorate([
    t()
], PcmNavigation.prototype, "mobileMenuIsOpen", void 0);
__decorate([
    t()
], PcmNavigation.prototype, "openSubmenusIndex", void 0);
customElements.define('pcm-navigation', PcmNavigation);

export { PcmNavigation };
